var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-btn',{attrs:{"outline":"info","darkWaves":"","rounded":"","size":"sm"}},[_vm._v(_vm._s(_vm.field))])}
var staticRenderFns = []

export { render, staticRenderFns }